import UpdateMeditationTranslationRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MeditationService/UpdateMeditationTranslationRequest";
import UpdateVoiceFileRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/UpdateVoiceFileRequest";
import MeditationAudioViewModel from "./meditationAudioViewModel";

export default class AudioGroupViewModel {
    audios: Array<MeditationAudioViewModel> = [];
    get isPaid(): boolean {
        return this.audios.every(x => x.isPaid) || false;
    }
    set isPaid(v: boolean) {
        this.audios.forEach(x => x.isPaid = v);
    }
    constructor(private languages: string[]) {
        this.audios = this.languages.map(l => new MeditationAudioViewModel({
            langCode: l
        }));
    }
    toServerModel(): UpdateMeditationTranslationRequest[] {
        const langs: string[] = [];
        this.audios.forEach(x => {
            if (langs.indexOf(x.langCode) == -1)
                langs.push(x.langCode)
        });
        const res = langs.map(x => new UpdateMeditationTranslationRequest({
            LangCode: x,
            VoiceFiles: this.audios.map(x => x.toServerModel())
        }));
        return res;
    }
    clone(): AudioGroupViewModel {
        const clone = new AudioGroupViewModel(this.languages)
        clone.audios = this.audios.map(x => x.clone());
        return clone;
    }
}
